export default __webpack_public_path__ + "static/media/blog_inner_26_1.6a2b92d5.png";